import React from 'react'
import DataClass from 'EurestoClass/Data'
import User from 'EurestoClass/User'
import Datagrid from '../Datagrid/index'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'

import Utils from 'EurestoFonction/Utils'
import EurestoDiv from 'EurestoComponents/EurestoDiv'

export default class extends React.Component {

  constructor (props) {
    super(props)

    let obj = Constants.dataObject[props.module + '-' + props.object].gridSubComponent && (Constants.dataObject[props.module + '-' + props.object].gridSubComponent.gridObject === undefined
      ? Constants.dataObject[props.module + '-' + props.object] : Constants.dataObject[Constants.dataObject[props.module + '-' + props.object].gridSubComponent.gridObject]) || {}

    this.state = {
      showSubComponent: false,
      mainPropsKey: Utils.getRandomNumber(),
      subPropsKey: Utils.getRandomNumber(),
      mainGridKey: Utils.getRandomNumber(),
      subGridKey: Utils.getRandomNumber(),
      action: 'add',
      subAction: 'add',
      object: props.object,
      type: props.type,
      template: Constants.dataObject[props.module + '-' + props.object].template,
      templateProps: {},
      subTemplate: obj.template,
      subTemplateProps: {},
      dataObject: Constants.dataObject[props.module + '-' + props.object],
      data: props.filter ? DataClass.filter(props.module, props.object, Constants.dataObject[props.module + '-' + props.object].gridSearch !== undefined ? Constants.dataObject[props.module + '-' + props.object].gridSearch : props.filter || {}) :
          DataClass.list(props.module, props.object, Constants.dataObject[props.module + '-' + props.object].gridSearch !== undefined ? Constants.dataObject[props.module + '-' + props.object].gridSearch : props.search || {}),
    }
    this.libelleGrid = ''
    this.libelleSubGrid = ''
    DataClass.addCbRestate(this.props.module, this.state.object, this.restate)
    if (this.state.dataObject.gridSubComponent !== undefined) {
      let [module, donnee] = this.state.dataObject.gridSubComponent.gridObject.split('-')
      DataClass.addCbRestate(module, donnee, this.subRestate)
    }
  }

  restate = data => {
    if ((this.state.dataObject.whenSub === undefined || this.state.dataObject.whenSub !== data.children)) {
      let state = {}
      if ((data.action === Constants.broadcastAction.delete && (data.user_id === User.User.get().id || (data.id === (this.state.mainRow || {}).id)))) {
        state = {
          showSubComponent: false,
          mainPropsKey: Utils.getRandomNumber(),
          subPropsKey: Utils.getRandomNumber(),
          mainGridKey: Utils.getRandomNumber(),
          subGridKey: Utils.getRandomNumber(),
          action: 'add',
          subAction: 'add',
          mainRow: {},
          subRow: {},
          templateProps: {},
          subTemplateProps: {},
        }
      } else if (data.action === Constants.broadcastAction.delete || data.user_id !== User.User.get().id) {
        state = {
          showSubComponent: false,
          mainGridKey: Utils.getRandomNumber(),
        }
      }
      const datas = this.props.filter ? DataClass.filter(this.props.module, this.state.object, Constants.dataObject[this.props.module + '-' + this.state.object].gridSearch !== undefined ? Constants.dataObject[this.props.module + '-' + this.state.object].gridSearch : this.props.filter || {}) :
          DataClass.list(this.props.module, this.state.object, Constants.dataObject[this.props.module + '-' + this.state.object].gridSearch !== undefined ? Constants.dataObject[this.props.module + '-' + this.state.object].gridSearch : this.props.search || {})

      this.setState({
        data: datas,
        ...state
      }, () => data.action !== Constants.broadcastAction.delete && data.user_id === User.User.get().id ? (this.view(datas.find(d => (this.state.mainRow && this.state.mainRow.ordre && this.state.mainRow.id && d.id === this.state.mainRow.id)) || data.results && data.results[0] || {})) : data.action === Constants.broadcastAction.delete && data.user_id === User.User.get().id && datas && datas.length > 0 && this.view(datas && datas[0]))
    }
  }

  subRestate = data => {
    let state = {}
    let obj = this.state.dataObject
    let restateGrid = false
    if (data.user_id === User.User.get().id) { // action fait pas l'utilisateur, recherger le tout
      restateGrid = true
    }
    // action fait par un autre utilisateur, vérifier, qu'ils regardent les mêmes données
    else if (data.action !== Constants.broadcastAction.delete && this.state.mainRow !== undefined && obj.gridSubComponent && obj.gridSubComponent.search !== undefined && obj.gridSubComponent.search.filter(o => o.doNotSearch !== true).length > 0) {
      restateGrid = true
      obj.gridSubComponent.search.filter(o => o.doNotSearch !== true).map(o => {
        if (restateGrid === true && this.state.mainRow[o.rowKey] === (data.results && data.results[0] || data || {})[o.searchKey]) {
          restateGrid = true
        } else {
          restateGrid = false
        }
      })
    } else if (data.action === Constants.broadcastAction.delete && this.state.mainRow !== undefined) {
      (this.state.subGrid && this.state.subGrid.data && this.state.subGrid.data || []).findIndex(o => {
        if (o.id === (data.results && data.results[0] || data || {}).id) {
          restateGrid = true
        }
      })
    }
    if (restateGrid) {
      const deleteMySubRow = (data.action === Constants.broadcastAction.delete && (data.user_id === User.User.get().id || (data.id === (this.state.subRow || {}).id)))
      const subGrid = this.state.dataObject.gridSubComponent !== undefined && this.state.mainRow && this.setSubGrid(this.state.mainRow)
      state = {
        subGridKey: Utils.getRandomNumber(),
        subGrid: subGrid,
      }
      this.setState({
        ...state
      }, () => !deleteMySubRow && data.user_id === User.User.get().id && this.subView(data.results && data.results[0] || subGrid && subGrid.data && subGrid.data && subGrid.data[0] || {}) || deleteMySubRow && this.view(this.state.mainRow || {}))
    }
  }

  componentDidMount () {
    this.view(this.state.data && this.state.data[0] || {})
  }

  setSubGrid = (row = {}) => {
    let search = {}
    let obj = this.state.dataObject
    if (obj.gridSubComponent.search !== undefined) {
      obj.gridSubComponent.search.map(o => {
        if (o.doNotSearch !== true) {
          search[o.searchKey] = row[o.rowKey]
        }
      })
    }
    let [module, donnee] = obj.gridSubComponent.gridObject.split('-')
    let dataSubComponent = DataClass.list(module, donnee, search)
    if (obj.gridSubComponent.gridObject !== undefined && donnee === Constants.donnee.info_tiers_donnees) {
      if (!Utils.isSubComponentAvailable(row.type_saisie_id)) {
        return false
      }
    }
    let subColumns = [];
    (obj.gridSubComponent.gridObject !== undefined ? Constants.dataObject[obj.gridSubComponent.gridObject].grid : obj.gridSubComponent.grid).map(col => {
      if (col.showOnSubComponent === undefined || col.showOnSubComponent === true) {
        let c = {
          Header: col.header,
          width: col.width,
          show: col.show !== undefined ? col.show : true
        }
        if (col.object !== undefined) {
          let a
          if (col.link === true) {
            a = dataSubComponent
          } else {
            a = col.object
          }
          c.Cell = row => {
            let l = a.find(o => (o.id === row[col.accessor]))
            return (
              <span>
                  {
                    l === undefined ? '' : l.libelle
                  }
                </span>
            )
          }
        } else if (col.cell) {
          c.Cell = col.cell
          c.accessor = col.accessor
        } else {
          c.accessor = col.accessor
        }
        subColumns.push(c)
      }
    })

    let subObj = this.state.dataObject.gridSubComponent.gridObject !== undefined
      ? this.state.dataObject : Constants.dataObject[this.state.dataObject.gridSubComponent.gridObject]

    if (dataSubComponent.length > 0) {
      return {
        onClick: this.subView,
        column: subColumns,
        data: dataSubComponent
      }
    } else {
      return false
    }
  }

  view = (row) => {
    const newState = {}

    if (this.state.dataObject.requete.get) {
      this.state.dataObject.requete.get.arg.map(key => {
        newState[key] = row[key]
      })
    }

    const stateSub = {}

    Constants.dataObject[this.props.module + '-' + this.props.object].gridSubComponent && (this.state.dataObject.gridSubComponent.search.map(o => {
      stateSub[o.searchKey] = row[o.rowKey]
    }))

    const showSubComponent = this.state.dataObject.gridSubComponent !== undefined && (this.state.object !== Constants.donnee.info_tiers || (this.state.object === Constants.donnee.info_tiers && Utils.isSubComponentAvailable(row.type_saisie_id)))

    const subGrid = this.state.dataObject.gridSubComponent !== undefined && this.setSubGrid(row) || {}

    this.setState({
      action: 'view',
      subAction: 'add',
      mainPropsKey: Utils.getRandomNumber(),
      subPropsKey: Utils.getRandomNumber(),
      mainGridKey: Utils.getRandomNumber(),
      subGridKey: Utils.getRandomNumber(),
      subGrid: subGrid,
      mainRow: row,
      subRow: {},
      templateProps: newState,
      //subTemplateProps: stateSub,
      showSubComponent: showSubComponent,
      mainScrollPosition: $('.MainGridDataForm .rt-tbody').first().scrollTop()
    }, () => {
      $('.MainGridDataForm .rt-tbody').first().scrollTop(this.state.mainScrollPosition)
      showSubComponent && this.subView(subGrid && subGrid.data && subGrid.data && subGrid.data[0] || {})
    })
  }

  subView = (row = {}) => {
    if (Object.keys(row).length === 0) {
      this.onCancelSub()
    } else {
      const obj = this.state.dataObject.gridSubComponent.gridObject === undefined
        ? this.state.dataObject : Constants.dataObject[this.state.dataObject.gridSubComponent.gridObject]

      const newState = {}

      Constants.dataObject[this.props.module + '-' + this.props.object].gridSubComponent && (this.state.dataObject.gridSubComponent.search.map(o => {
        newState[o.searchKey] = row[o.rowKey]
      }))
      obj.requete.get.arg.map(key => {
        newState[key] = row[key]
      })

      this.setState({
        subAction: 'view',
        subRow: row,
        subGridKey: Utils.getRandomNumber(),
        subPropsKey: Utils.getRandomNumber(),
        subTemplateProps: newState,
        subScrollPosition: $('.SubGridDataForm .rt-tbody').first().scrollTop()
      }, () => {
        $('.SubGridDataForm .rt-tbody').first().scrollTop(this.state.subScrollPosition)
      })
    }
  }

  actionAvailable = (action, row = {}) => {
    if (action === 'update' || action === 'delete' || action === 'view') {
      return row && Object.keys(row).length > 0 && (row.autorisation_modification === undefined || row.autorisation_modification === 1)
    }
  }

  onCancel = (toAdd = true) => {
    if (toAdd) {
      this.setState({
        showSubComponent: false,
        mainPropsKey: Utils.getRandomNumber(),
        subPropsKey: Utils.getRandomNumber(),
        mainGridKey: Utils.getRandomNumber(),
        subGridKey: Utils.getRandomNumber(),
        action: 'add',
        subAction: 'add',
        mainRow: {},
        lastMainRow: EurestoClone(this.state.mainRow),
        subRow: {},
        templateProps: {},
        subTemplateProps: {},
      }, this.forceUpdate)
    } else {
      this.view(this.state.lastMainRow || {})
    }
  }

  onCancelSub = (toAdd = true) => {
    if (toAdd) {
      const newState = {}

      this.state.dataObject.gridSubComponent.search.map(o => {
        newState[o.searchKey] = this.state.mainRow[o.rowKey]
      })

      this.setState({
        subPropsKey: Utils.getRandomNumber(),
        subGridKey: Utils.getRandomNumber(),
        subAction: 'add',
        subRow: {},
        lastSubRow: EurestoClone(this.state.subRow),
        subTemplateProps: newState,
      }, this.forceUpdate)
    } else {
      this.subView(this.state.lastSubRow)
    }
  }

  render () {
    let columns = []
    let obj = this.state.dataObject
    obj.grid.map(col => {
      if (col.showOnSubComponent === undefined || col.showOnSubComponent !== true) {
        let c = {
          Header: col.header,
          accessor: col.accessor,
          show: col.show !== undefined ? col.show : true,
          width: col.width
        }
        if (col.object !== undefined) {
          let a
          if (col.link === true) {
            const [module, donnee] = col.object.split('-')
            a = DataClass.list(module, donnee, col.search !== undefined ? col.search : {})
          } else {
            a = col.object
          }
          c.Cell = row => {
            if (Utils.isJsonStringArray(row.original[col.accessor])) {
              let l = []
              Utils.isJsonStringArray(row.original[col.accessor]).map(o => {
                const r = a.find(e => {
                  return ((col.link === true ? e[Constants.dataObject[col.object].modifSearch] : e.id) === o)
                })
                if (r !== undefined) {
                  l.push(r.libelle)
                }
              })
              return (
                <span>
                  {
                    l === undefined ? '' : l.join(', ')
                  }
                </span>
              )
            } else {
              let l = a.find(o => {
                return ((col.link === true ? o[Constants.dataObject[col.object].modifSearch] : o.id) === row.original[col.accessor])
              })
              return (
                <span>
                  {
                    l === undefined ? '' : l.libelle
                  }
                </span>
              )
            }
          }
        } else if (col.cell) {
          c.Cell = col.cell
          c.accessor = col.accessor
        } else {
          c.accessor = col.accessor
        }
        columns.push(c)
      }
    })

    return (<Grid container>
        <this.state.template
          {...this.state.templateProps}
          search={this.props.search || {}}
          formProps={{
            borderLeft: true,
            showTab: false,
            style: { padding: 0 },
            parentComponent: this.formPage(columns)
          }}
          key={this.state.mainPropsKey}
          action={this.state.action}
          onCancel={this.onCancel}
          isAllow={{
            add: true,
            update: this.actionAvailable('update', this.state.mainRow),
            delete: this.actionAvailable('delete', this.state.mainRow),
            archive: this.state.mainRow && Object.keys(this.state.mainRow).length > 0,
            duplicate: (this.state.data || []).length > 0,
          }}
        />
        {
          this.state.showSubComponent &&
          <this.state.subTemplate
            {...this.state.subTemplateProps}
            search={this.props.subSearch || {}}
            formProps={{
              borderLeft: true,
              showTab: false,
              style: { padding: 0 },
              parentComponent: this.formSubPage()
            }}
            key={this.state.subPropsKey}
            action={this.state.subAction}
            onCancel={this.onCancelSub}
            sub={true}
            isAllow={{
              add: !(this.props.object === Constants.donnee.info_tiers &&
                (
                  ((!Utils.isSubComponentAvailable(this.state.mainRow.type_saisie_id))) ||
                  ((this.state.mainRow.autorisation_saisie === 0 && (!User.TypeAccess.get(Constants.access.EURESTO)))) ||
                  ((!User.isAddUpdateDeleteAvaibleForMe() && this.state.mainRow.autorisation_modification === 0)))),
              update: this.actionAvailable('update', this.state.subRow),
              delete: this.actionAvailable('delete', this.state.subRow),
              archive: this.state.subRow && Object.keys(this.state.subRow).length > 0,
              duplicate: !(this.props.object === Constants.donnee.info_tiers &&
                (
                  ((!Utils.isSubComponentAvailable(this.state.mainRow.type_saisie_id))) ||
                  ((this.state.mainRow.autorisation_saisie === 0 && (!User.TypeAccess.get(Constants.access.EURESTO)))) ||
                  ((!User.isAddUpdateDeleteAvaibleForMe() && this.state.mainRow.autorisation_modification === 0))))
                && (this.state.subGrid && this.state.subGrid.data || []).length > 0
            }}/>
        }
      </Grid>
    )
  }

  formPage = (columns) => (props) =>  <EurestoDiv title={props.libelle}>
    <Grid container spacing={0} direction="row" justify="center" alignItems="flex-start"
          style={{
            margin: 0,
            padding: 0,
          }}>

      <Grid item xs={this.state.object === Constants.donnee.profil ? 8 :
        ((this.state.object === Constants.donnee.template_type || this.state.object === Constants.donnee.carcasse) && 4 || 9)}
            style={{
              margin: 0,
              padding: 0,
              position: 'relative',
              height: '100%',
              maxHeight: User.CalculHeight.getHeightWanted(50, this.state.dataObject.gridSubComponent !== undefined && ' / 2 ' || '')
            }}>
        <Datagrid
          key={this.state.mainGridKey}
          onClick={this.view}
          columnsName={columns}
          style={{ maxHeight: '100%' }}
          indexSelected={(this.state.data || []).findIndex(o => o.id === (this.state.mainRow || {}).id)}
          isSubComponent={true}
          className={'MainGridDataForm'}
          data={this.state.data}
          type="donnees_annexes"/>
      </Grid>
      <Grid item
            xs={this.state.object === Constants.donnee.profil ? 4 : ((this.state.object === Constants.donnee.template_type || this.state.object === Constants.donnee.carcasse) && 8 || 3)}
            style={{ margin: 0, padding: 0, height: '100%' }}>
        {props.children}
      </Grid>
    </Grid>
  </EurestoDiv>

  formSubPage = () => props => <EurestoDiv title={props.libelle}>
      <Grid container spacing={0} direction="row"
            justify="center" alignItems="flex-start"
            style={{
              margin: 0,
              padding: 0
            }}>
        <Grid item xs={9} style={{
          margin: 0,
          padding: 0,
          position: 'relative',
          height: '100%',
          maxHeight: User.CalculHeight.getHeightWanted(50, ' / 2')
        }}>
          {/*subComponent(this.state.mainRow)*/
            <Datagrid
              key={this.state.subGridKey}
              isSubComponent={true}
              indexSelected={(this.state.subGrid && this.state.subGrid.data || []).findIndex(o => o.id === (this.state.subRow || {}).id)}
              className={'SubGridDataForm'}
              style={{ maxHeight: '100%' }}
              onClick={this.state.subGrid.onClick}
              columnsName={this.state.subGrid.column || []}
              data={this.state.subGrid && this.state.subGrid.data || []} type="donnees_annexes"
            />}
        </Grid>
        <Grid item xs={3}
              style={{ margin: 0, padding: 0, height: '100%' }}>
          {props.children}
        </Grid>
      </Grid>
    </EurestoDiv>

}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/index.js